import { Navigate } from "react-router";

export default function Redirect({ to }: { to: string }) {
  console.log("Redirecting to", to);
  return <Navigate to={to} replace />;
}
